import { Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

function BankDetailsForm({ form, setForm, stepSubmitted }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            bank_details: {
                ...prev.bank_details,
                [name]: value
            }
        }));
    };

    const accountTypeOptions = [
        { value: 'savings', label: 'Savings' },
        { value: 'current', label: 'Current' },
        { value: 'cash_credit', label: 'Cash Credit' },
        { value: 'overdraft', label: 'Overdraft' },
    ];

    const handleSelectChange = (selectedOption, { name }) => {
        setForm((prev) => ({
            ...prev,
            [name]: selectedOption?.value || '',
        }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Account Holder Name</Form.Label>
                        <Form.Control
                            name="account_name"
                            value={form.bank_details.account_name}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                            name="account_number"
                            value={form.bank_details.account_number}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                            name="bank"
                            value={form.bank_details.bank}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Branch</Form.Label>
                        <Form.Control
                            name="branch"
                            value={form.bank_details.branch}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>IFSC Code</Form.Label>
                        <Form.Control
                            name="ifsc"
                            value={form.bank_details.ifsc}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>

                
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2 fs-9">
                        <Form.Label>Account Type</Form.Label>
                        <Select
                            name="account_type"
                            value={accountTypeOptions.find(opt => opt.value === form.account_type)}
                            onChange={handleSelectChange}
                            options={accountTypeOptions}
                            placeholder="-- Select Account Type --"
                        />
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
}

export default BankDetailsForm;
